import React from "react";
const autobind = require("class-autobind").default;
import { FormGroup } from "../../form/group/index";
import { Input } from "../../form/input/index";
import { InputBox } from "../../form/input.box/index";
import { Button } from "../../button/index";
import { FaBars } from "react-icons/fa";
import { Tooltip } from "../../tooltip/index";
import { arrayMove, SortableContainer, SortableElement, SortableHandle } from "react-sortable-hoc";
import { EllipsisIcon } from "../../bumpViews/ellipsis";
import { BottomMenuControls } from "../opening_hours/bottom_menu_edit";
import { ButtonListItem } from "./button-list";
import styled from "styled-components";
import { IconDelete } from "../opening_hours/opening_hours_v2";
const Wrapper = styled("div") `
 @media (max-width: 767px) {
   .menu-item-active {
        background: #FFF3F3;
        border: 1px solid #FB2F2F;
    }
`;
export const SortableItemWrapper = styled.div `
width: 100%;
	.mobile-view {
    display: none;
  }
  @media (max-width: 767px) {
    .desktop-view {
      display: none;
    }
    .mobile-view {
      display: flex;
	  padding: none;
    }
 
`;
const DragHandle = SortableHandle(() => {
    return (React.createElement(InputBox, { className: "no-round width40 flex-center cursor-move" },
        React.createElement("p", { className: "big font-bold" },
            React.createElement(FaBars, null))));
});
const SortableItem = SortableElement((props) => {
    const { item, itemIndex, change, remove, isMobile, setOpenActionItem, setActiveIndex, activeIndex, openActionItem } = props;
    const handleOpenAction = (index) => {
        setActiveIndex(index);
        setOpenActionItem(!openActionItem);
    };
    return (React.createElement(SortableItemWrapper, null,
        React.createElement(Wrapper, { className: "desktop-view" },
            React.createElement("div", { key: itemIndex, className: activeIndex === itemIndex && openActionItem ? "menu-item-active flex-line" : "flex-line", style: { alignItems: "flex-end" } },
                React.createElement(DragHandle, null),
                React.createElement(InputBox, { className: "no-round width64 text-center" },
                    React.createElement("p", { className: "big font-bold", style: { lineHeight: "36px" } }, itemIndex + 1)),
                React.createElement("div", { className: "flex-line flex-grow", style: { alignItems: "flex-end" } },
                    React.createElement(FormGroup, { className: "m-b-0 flex-grow", small_title: true, no_border: true },
                        React.createElement(Input, { type: "text", className: "no-round", value: item.name, placeholder: "Name", required: true, onChange: (e) => change(itemIndex, "name", e.target.value) }))),
                React.createElement(Tooltip, { text: "Delete", width: 65, position: "top", disable: itemIndex !== 0 },
                    React.createElement(Button, { type: "button", className: "no-round", paddinglr: 5, color: "white", onClick: () => remove(itemIndex), style: { height: '38px' } },
                        React.createElement(IconDelete, null))))),
        React.createElement(Wrapper, { className: "mobile-view" },
            React.createElement("div", { key: itemIndex, className: activeIndex === itemIndex && openActionItem ? "menu-item-active flex-line" : "flex-line", style: { alignItems: "flex-end", width: '100%' } },
                React.createElement(InputBox, { className: "no-round width64 text-center" },
                    React.createElement("p", { className: "big font-bold", style: { lineHeight: "36px" } }, itemIndex + 1)),
                React.createElement("div", { className: "flex-line flex-grow", style: { alignItems: "flex-end" } },
                    React.createElement(FormGroup, { className: "m-b-0 flex-grow", small_title: true, no_border: true },
                        React.createElement(Input, { type: "text", className: "no-round", value: item.name, placeholder: "Name", required: true, onChange: (e) => change(itemIndex, "name", e.target.value) }))),
                React.createElement(Tooltip, { text: "Delete", width: 65, position: "top", disable: itemIndex !== 0 },
                    React.createElement(Button, { type: "button", className: "no-round", paddinglr: 5, color: "white", onClick: () => handleOpenAction(itemIndex), style: { height: '38px' } },
                        React.createElement(EllipsisIcon, null)))))));
});
const SortableItemContainer = SortableContainer((props) => {
    return (React.createElement("div", null, props.items.map((item, i) => (React.createElement(SortableItem, { key: `item-${i}`, index: i, item: item, itemIndex: i, change: props.change, remove: props.remove, isMobile: props.isMobile, setActiveIndex: props.setActiveIndex, setOpenActionItem: props.setOpenActionItem, activeIndex: props.activeIndex, openActionItem: props.openActionItem })))));
});
export class FieldDishIngredientsV2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeIndex: -1,
            openActionItem: false,
        };
    }
    remove = (i) => {
        const values = ([...this.props.values]);
        values.splice(i, 1);
        this.props.onChange(values);
    };
    change = (i, key, value) => {
        const values = [...this.props.values];
        values[i][key] = value;
        this.props.onChange(values);
    };
    setDefault = (i, quantity) => {
        this.props.onChange(this.props.values.map((item, index) => ({
            ...item,
            quantity: i === index ? quantity : 0,
        })));
    };
    onSortEnd = ({ oldIndex, newIndex }) => {
        const { onChange, values } = this.props;
        onChange(arrayMove(values, oldIndex, newIndex));
    };
    onUp = (index) => {
        const { onChange, values } = this.props;
        if (index > 0) {
            const updatedValues = arrayMove(values, index, index - 1);
            onChange(updatedValues);
            this.setState({ activeIndex: index - 1 });
        }
    };
    onDown = (index) => {
        const { onChange, values } = this.props;
        if (index < values.length - 1) {
            const updatedValues = arrayMove(values, index, index + 1);
            onChange(updatedValues);
            this.setState({ activeIndex: index + 1 });
        }
    };
    render() {
        const { values } = this.props;
        return (React.createElement(SortableItemWrapper, null,
            React.createElement(SortableItemContainer, { helperClass: "zindex-15 bsl-2", pressDelay: 50, useDragHandle: true, items: values, change: this.change, remove: this.remove, onSortEnd: this.onSortEnd, isMobile: this.props.isMobile, setOpenActionItem: (isActive) => this.setState({ openActionItem: isActive }), openActionItem: this.state.openActionItem, setActiveIndex: (index) => this.setState({ activeIndex: index }), activeIndex: this.state.activeIndex }),
            this.state.openActionItem && this.state.activeIndex >= 0 && (React.createElement(SortableItemWrapper, { className: "mobile-view" },
                React.createElement(BottomMenuControls, { buttonList: ButtonListItem(() => this.onUp(this.state.activeIndex), () => this.onDown(this.state.activeIndex), () => this.remove(this.state.activeIndex), () => this.setState({ openActionItem: false })) })))));
    }
}
//# sourceMappingURL=ingredients-v2.js.map